import {isArray} from 'underscore'
import BaseFormValidationMixin from './base-form-validation.mixin'

/**
 * @mixin
 */
export default {
    mixins: [BaseFormValidationMixin],
    methods: {
        disablePrependIconTabIndex () {
            this.$nextTick(() => {
                const icons = Array.from(document.getElementsByClassName('v-input__icon--prepend'))

                icons.forEach(el => {
                    const buttons = Array.from(el.getElementsByTagName('button'))
                    buttons.forEach(button => {
                        button.tabIndex = -1
                    })
                })
            })
        },
        handleAppendClick () {
            /**
             * Append click event.
             * @type {undefined}
             */
            this.$emit('click:append')
        },
        handleBlur () {
            /**
             * Blur event.
             * @type {undefined}
             */
            this.$emit('blur')
        },
        handleFocus (value) {
            /**
             * Focus event.
             * @type {object}
             */
            this.$emit('focus', value)
        },
        handleInput (value) {
            /**
             * Input event.
             * @type {string}
             */
            this.$emit('input', value)
        },
        handleEnter () {
            /**
             * Enter event.
             * @type {undefined}
             */
            this.$emit('enter')
        },
        handlePrependClick (ref) {
            /**
             * Prepend click event.
             * @type {undefined}
             */
            this.$emit('click:prepend')

            if (ref && (ref = this.$refs[ref])) {
                ref = isArray(ref) ? ref[0] : ref

                const active = ref.isMenuActive

                if (active) {
                    ref.blur()
                    ref.isMenuActive = false
                } else {
                    ref.focus()
                    ref.isMenuActive = true
                }
            }
        }
    }
}
